<template>
  <div class="home_container" :class="[isNewSkin ? 'home_container_bg_new' : 'home_container_bg']">
    <div>
      <div class="header_container">
        <div class="logo">
          <img src="../assets/image/logo.png" alt="达美乐比萨" />
        </div>
        <div class="centerBtn">
          <div class="RuleBtn" @click="activityRule()">
            <!-- 旧按钮路径 -->
            <img v-if="!isNewSkin" src="../assets/image/button/activityRule.png" alt="活动规则" />
            <!-- 新按钮路径 -->
            <img v-else src="../assets/image/gameImages/button/activityRule.png" alt="活动规则" />
          </div>
        </div>
        <div class="rightBtn">
          <div class="myGiftBtn" @click="myGiftBtn()">
            <!-- 旧按钮路径 -->
            <img v-if="!isNewSkin" src="../assets/image/button/myGift.png" alt="我的奖品" />
            <!-- 新按钮路径 -->
            <img v-else src="../assets/image/gameImages/button/myGift.png" alt="我的奖品" />
          </div>
        </div>
        <div class="rightIcon"></div>
      </div>
      <div class="content_container">
        <div class="content_box" :class="[isNewSkin ? 'content_box_bg_new' : 'content_box_bg']">
          <div class="indexLine">
              <p>尊敬的用户</p>
              <p>此活动已结束</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      isNewSkin: false, // 是否新皮肤
    };
  },

  computed: {
    userInfo02: function() {
      return this.$store.getters.getInfo02;
    },
    userInfo: function() {
      return this.$store.getters.getInfo;
    }
  },
  mounted() {
    this.isNewSkin = sessionStorage.getItem('isNewSkin') ? true : false;
  },
  methods: {
    activityRule() {
      this.$router.push({ name: "activityRule" });
    },

    myGiftBtn() {
      if (!this.userInfo) {
        return Toast("无法获取用户信息，暂无法查看");
      }
      this.$router.push({ name: "myGiftAll" });
    },

  },
  beforeCreate() {
    document.title = "抽奖";
  }
};
</script>

<style lang="scss" scoped>
.home_container {
  width: 100%;
  height: 100%;
  border-top: 1px solid transparent;
  // background-image: url("../assets/image/bgc01.png");
  background-size: 100% 100%;
  .header_container {
    width: 100%;
    height: 60px;
    display: flex;
    margin-top: 20px;
    .logo {
      flex: 3;
      padding-left: 15px;
      img {
        width: 100%;
      }
    }
    .centerBtn {
      flex: 2;
      padding-left: 20px;
      .RuleBtn {
        width: 90%;
        height: 100%;
        img {
          width: 100%;
        }
      }
    }
    .rightBtn {
      flex: 2;
      padding-left: 10px;
      .myGiftBtn {
        width: 90%;
        height: 100%;
        img {
          width: 100%;
        }
      }
    }
    .rightIcon {
      width: 20px;
      padding-left: 10px;
      padding-top: 5px;
      img {
        width: 50%;
      }
    }
  }
  .content_container {
    margin-top: 30px;
    width: 100%;
    height: 500px;
    .content_box {
      width: 370px;
      height: 100%;
      margin: 0 auto;
      // background-image: url(../assets/image/blueBgc02.png);
      background-size: cover;
      padding-top: 90px;
      .indexLine {
        width: 55%;
        height: 80%;
        margin: 0 auto;
        // background-color: #fff;
        display: flex;
        flex-direction: column;
        // justify-content: center;
        padding-top: 100px;
        align-items: center;
        font-size: 23px;
        color: white;
        // font-weight: bold;
        p {
            padding: 0;
            margin: 0;
            line-height: 40px;
            letter-spacing: 5px;
            text-shadow: -1px -1px 3px #000;
        }
      }
    }
    .content_box_bg {
      // 旧背景路径
      background-image: url('../assets/image/blueBgc02.png');
    }
    .content_box_bg_new {
      // 新背景路径
      background-image: url('../assets/image/gameImages/blueBgc02.png');  
    }
  }
}
.home_container_bg {
  // 旧背景路径
	background-image: url('../assets/image/bgc01.png');
}
.home_container_bg_new {
  // 新背景路径
  background-image: url('../assets/image/gameImages/bgc01.png');
}
</style>
